import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { ref } from '@dbk-legacy/muster/utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { pure } from '@dbk/ui-react-utils';
import { FormattedMessage } from '@dbk/format';
import { Tab, Tabs } from '@dbk/ui-tabs';
import SortingHeader from '../../../components/common/sorting-header';
import styles from './header-tabs.styles';
import { KEY_CODE } from '../../../constants'


function HeaderTabs({ maturities, resetSort, messages, dateRangeFn }) {
  const {
    tabs,
    selectedTabIndex,
    setSelectedTabIndex,
    openCalendar,
  } = maturities;

  const handleTabChange = (i, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      const tab = tabs[i];
      if (tab.periodType !== 'custom') {
        resetSort();
        dateRangeFn.setShowDateRange(false);
      } else dateRangeFn.setShowDateRange(true);
      setSelectedTabIndex(i);
    }
  }

  return (
    <View id="tab_maturities_headerTabs_test" style={styles.root}>
      <Tabs
        stretch
        secondary
        handleSelectedIndex={handleTabChange}
        selectedIndex={selectedTabIndex}
      >
        {
          tabs.map((tab, i) => <Tab className="tabFocus" testID={"tab_maturities_inner_headerTabs_test_"+i} onKeyDown={(event) => handleTabChange(i, event)} renderLabel={() => 
            <div aria-label={tab.periodType=="custom"? messages['app.maturities.selectDatePicker'] : tab.periodNo + tab.periodType + messages['app.maturities.filter']}>
              <FormattedMessage
                id={`app.maturities.overview.tabs.labels.${tab.periodType}`}
                values={{ n: tab.periodNo }}
              />
            </div>
          } />)
        }
      </Tabs>

      <SortingHeader
        enabled={false}
        showBorder={false}
        messages={messages}
      />
    </View>
  );
}

HeaderTabs.propTypes = {
  maturities: PropTypes.shape({
    tabs: PropTypes.arrayOf(PropTypes.shape({
      periodType: PropTypes.string,
      periodNo: PropTypes.number,
      fromDate: PropTypes.date,
      toDate: PropTypes.date,
    })),
  }),
  resetSort: PropTypes.func,
};

export default createContainer({
  $fragments: {
    maturities: {
      tabs: {
        $type: 'list',
        $range: {
          offset: 0,
          length: ref('maturities.tabs.length'),
        },
        $node: {
          periodType: true,
          periodNo: true,
          fromDate: true,
          toDate: true,
        },
      },
      selectedTabIndex: true,
      setSelectedTabIndex: { $set: 'selectedTabIndex' },
      openCalendar: { $call: 'calendar.open' },
    },
  },

})(pure(HeaderTabs));
